import React from 'react'
import { LoadingComponent } from './styles'
import { TimelineViewByTrimester } from './TimelineByPeriod/TimelineViewByTrimester'
import { TimelineViewByMonths } from './TimelineByPeriod/TimelineViewByMonths'
import { TimelineViewByDays } from './TimelineByPeriod/TimelineViewByDays'
import { IHealthProcedures } from '~/interfaces'
import { message } from '~/services'
import { useMaternalInfantHealthProcedures, useOpenCloseUpdater } from '~/context'
import { filterHealthProceduresPer, isConduct, isOmics } from '~/utils'
import { getGestationRangeBy, getNeonateRangeBy, getPuerperiumRangeBy } from '~/utils/dashboard/timeline/maternalInfant'
import { SpinnerIconLoader, TimelineSections } from '~/components/shared'
import { IconComponent } from '~/assets/icons/component'
import { isHealthProceduresGroupsEquals } from '~/utils/dashboard/timeline/mappers'

export const TimelineMaternalInfant = (): JSX.Element => {
  const { open: openSidePanel } = useOpenCloseUpdater()
  const {
    puerperiumHealthProcedures,
    neonateHealthProcedures,
    infantHealthProcedures,
    gestationHealthProcedures,

    setOpenConductCardList,
    setOpenOmicsCardList,

    isMotherTimelineSelected,
    isBabyTimelineSelected,

    handleSelectedModalHealthProcedures,
    isLoadingTimeline,
    selectedPregnancy,

    resetSidePanelEvents,
    updateSidePanelEvents,
    sidePanelEvents
  } = useMaternalInfantHealthProcedures()

  const handleSelectedHealthProcedure = (healthProcedure: IHealthProcedures[]): void => {
    const hasOnlyOneSelectedHealthProcedure = healthProcedure.length === 1
    const isMedicalEventSelectedEqualToTheListedInSidePanel = isHealthProceduresGroupsEquals(
      healthProcedure,
      sidePanelEvents
    )
    const omicsInSelectedHealthProcedure = filterHealthProceduresPer(healthProcedure, isOmics)
    const conductsInSelectedHealthProcedure = filterHealthProceduresPer(healthProcedure, isConduct)

    if (hasOnlyOneSelectedHealthProcedure) {
      handleSelectedModalHealthProcedures(healthProcedure[0])
      return
    }

    if (isMedicalEventSelectedEqualToTheListedInSidePanel) {
      resetSidePanelEvents()
      return
    }

    if (omicsInSelectedHealthProcedure.length > 0) {
      setOpenOmicsCardList(true)
    }
    if (conductsInSelectedHealthProcedure.length > 0) {
      setOpenConductCardList(true)
    }

    updateSidePanelEvents(healthProcedure)
    openSidePanel()
  }

  if (isLoadingTimeline) {
    return (
      <LoadingComponent>
        <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
      </LoadingComponent>
    )
  }

  if (isMotherTimelineSelected) {
    return (
      <TimelineSections
        sections={[
          {
            title: message('maternalInfant.puerperal'),
            content: (
              <TimelineViewByDays
                healthProcedures={puerperiumHealthProcedures}
                timelineRange={getPuerperiumRangeBy(selectedPregnancy)}
                onSelectEvent={handleSelectedHealthProcedure}
              />
            )
          },
          {
            title: message('maternalInfant.pregnant'),
            content: (
              <TimelineViewByTrimester
                healthProcedures={gestationHealthProcedures}
                timelineRange={getGestationRangeBy(selectedPregnancy)}
                onSelectEvent={handleSelectedHealthProcedure}
              />
            )
          }
        ]}
      />
    )
  }

  if (isBabyTimelineSelected) {
    return (
      <TimelineSections
        sections={[
          {
            title: message('maternalInfant.infant'),
            content: (
              <TimelineViewByMonths
                healthProcedures={infantHealthProcedures}
                onSelectEvent={handleSelectedHealthProcedure}
              />
            )
          },
          {
            title: message('maternalInfant.neonate'),
            content: (
              <TimelineViewByDays
                healthProcedures={neonateHealthProcedures}
                timelineRange={getNeonateRangeBy(selectedPregnancy)}
                onSelectEvent={handleSelectedHealthProcedure}
              />
            )
          },
          {
            title: message('maternalInfant.gestation'),
            content: (
              <TimelineViewByTrimester
                healthProcedures={gestationHealthProcedures}
                timelineRange={getGestationRangeBy(selectedPregnancy)}
                onSelectEvent={handleSelectedHealthProcedure}
              />
            )
          }
        ]}
      />
    )
  }

  return <></>
}
